module.exports = __webpack_public_path__ + "img/appstore.6ef4637e.svg";